/* eslint-disable import/named */
import { actionCreator } from 'utils';
import * as CustomerTypes from '../types/customerTypes';

// L O A D   C U S T O M E R S   W I T H   P A G I N A T I O N  &  S O R T
export function loadCustomers() {
    return {
        type: CustomerTypes.LOAD_CUSTOMERS,
    };
}

export function loadCustomersRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMERS, 'res'),
        data,
    };
}

export function loadCustomersErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMERS, 'err'),
    };
}

export function setCustomerPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_CUSTOMER_PAGINATION,
        key,
        pagination,
    };
}

export function setCustomerSort(sort) {
    return {
        type: CustomerTypes.SET_CUSTOMER_SORT,
        sort,
    };
}
// L O A D   C U S T O M E R S   W I T H   P A G I N A T I O N  &  S O R T

// S E T   C U S T O M E R S    F I L T E R
export function setCustomerFilters(key, value) {
    return {
        type: CustomerTypes.SET_CUSTOMER_FILTER,
        key,
        value,
    };
}

export function setCustomerFiltersRes(data) {
    return {
        type: actionCreator(CustomerTypes.SET_CUSTOMER_FILTER, 'res'),
        data,
    };
}

export function resetCustomerFilters() {
    return {
        type: CustomerTypes.RESET_CUSTOMER_FILTERS,
    };
}
// S E T   C U S T O M E R S    F I L T E R

// A D D   N E W   C U S T O M E R S
export function addNewCustomer(data, contact) {
    return {
        type: CustomerTypes.ADD_NEW_CUSTOMER,
        data,
        contact,
    };
}

export function addNewCustomerRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_CUSTOMER, 'res'),
        loading,
        success,
    };
}

export function addNewCustomerErr(error) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_CUSTOMER, 'err'),
        error,
    };
}
// A D D   N E W   C U S T O M E R S

// L O A D   E D I T A B L E   C U S T O M E R
export function loadEditableCustomer(id) {
    return {
        type: CustomerTypes.LOAD_EDITABLE_CUSTOMER,
        id,
    };
}

export function loadEditableCustomerRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_EDITABLE_CUSTOMER, 'res'),
        data,
    };
}

export function loadEditableCustomerErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_EDITABLE_CUSTOMER, 'err'),
    };
}

export function setEmptyEditableCustomer() {
    return {
        type: CustomerTypes.SET_EMPTY_EDITABLE_CUSTOMER,
    };
}
// L O A D   E D I T A B L E   C U S T O M E R

// E D I T   C U S T O M E R S
export function editCustomer(data, contact) {
    return {
        type: CustomerTypes.EDIT_CUSTOMER,
        data,
        contact,
    };
}

export function editCustomerRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.EDIT_CUSTOMER, 'res'),
        loading,
        success,
    };
}

export function editCustomerErr() {
    return {
        type: actionCreator(CustomerTypes.EDIT_CUSTOMER, 'err'),
    };
}
// E D I T   C U S T O M E R S


// L O A D   C O N T A C T S   W I T H   P A G I N A T I O N  &  S O R T
export function loadContacts(id) {
    return {
        type: CustomerTypes.LOAD_CONTACTS,
        id,
    };
}

export function loadContactsRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CONTACTS, 'res'),
        data,
    };
}

export function loadContactsErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CONTACTS, 'err'),
    };
}

export function setContactPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_CONTACT_PAGINATION,
        key,
        pagination,
    };
}

export function setContactSort(key, type) {
    return {
        type: CustomerTypes.SET_CONTACT_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function setContactFilter(key, value) {
    return {
        type: CustomerTypes.SET_CONTACT_FILTER,
        key,
        value,
    };
}
// L O A D   C O N T A C T S   W I T H   P A G I N A T I O N  &  S O R T


// A D D   N E W   C O N T A C T
export function addNewContact(data) {
    return {
        type: CustomerTypes.ADD_NEW_CONTACT,
        data,
    };
}

export function addNewContactRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_CONTACT, 'res'),
        loading,
        success,
    };
}

export function addNewContactErr(error) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_CONTACT, 'err'),
        error,
    };
}
// A D D   N E W   C O N T A C T

// E D I T   C O N T A C T
export function editContact(data) {
    return {
        type: CustomerTypes.EDIT_CONTACT,
        data,
    };
}

export function editContactRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.EDIT_CONTACT, 'res'),
        loading,
        success,
    };
}

export function editContactErr() {
    return {
        type: actionCreator(CustomerTypes.EDIT_CONTACT, 'err'),
    };
}
// E D I T   C O N T A C T

// A D D   C U S T O M E R   A D D R E S S
export function addNewAddress(data) {
    return {
        type: CustomerTypes.ADD_NEW_ADDRESS,
        data,
    };
}

export function addNewAddressRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_ADDRESS, 'res'),
        loading,
        success,
    };
}

export function addNewAddressErr(error) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_ADDRESS, 'err'),
        error,
    };
}
// A D D   C U S T O M E R   A D D R E S S

// L O A D   S H I P P I N G   A D D R E S S E S   W I T H   P A G I N A T I O N  &  S O R T
export function loadShippingAddresses(customerId) {
    return {
        type: CustomerTypes.LOAD_SHIPPING_ADDRESSES,
        customerId,
    };
}

export function loadShippingAddressesRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_SHIPPING_ADDRESSES, 'res'),
        data,
    };
}

export function loadShippingAddressesErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_SHIPPING_ADDRESSES, 'err'),
    };
}

export function setShippingAddressesPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_SHIPPING_ADDRESS_PAGINATION,
        key,
        pagination,
    };
}

export function setShippingAddressesSort(key, type) {
    return {
        type: CustomerTypes.SET_SHIPPING_ADDRESS_SORT,
        sort: {
            key,
            type,
        },
    };
}
// L O A D   S H I P P I N G   A D D R E S S E S   W I T H   P A G I N A T I O N  &  S O R T

// L O A D   S H I P P I N G   A D D R E S S E S   F I L T E R
export function setShippingAddressesFilters(key, value) {
    return {
        type: CustomerTypes.SET_SHIPPING_ADDRESS_FILTER,
        key,
        value,
    };
}

export function resetShippingAddressesFilters() {
    return {
        type: CustomerTypes.RESET_SHIPPING_ADDRESS_FILTERS,
    };
}
// L O A D   S H I P P I N G   A D D R E S S E S   F I L T E R

// L O A D   B I L L I N G   A D D R E S S E S   W I T H   P A G I N A T I O N  &  S O R T
export function loadBillingAddresses(customerId) {
    return {
        type: CustomerTypes.LOAD_BILLING_ADDRESSES,
        customerId,
    };
}

export function loadBillingAddressesRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_BILLING_ADDRESSES, 'res'),
        data,
    };
}

export function loadBillingAddressesErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_BILLING_ADDRESSES, 'err'),
    };
}

export function setBillingAddressesPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_BILLING_ADDRESS_PAGINATION,
        key,
        pagination,
    };
}

export function setBillingAddressesSort(key, type) {
    return {
        type: CustomerTypes.SET_BILLING_ADDRESS_SORT,
        sort: {
            key,
            type,
        },
    };
}
// L O A D   B I L L I N G   A D D R E S S E S   W I T H   P A G I N A T I O N  &  S O R T

// L O A D   B I L L I N G   A D D R E S S E S   F I L T E R
export function setBillingAddressesFilters(key, value) {
    return {
        type: CustomerTypes.SET_BILLING_ADDRESS_FILTER,
        key,
        value,
    };
}

export function resetBillingAddressesFilters() {
    return {
        type: CustomerTypes.RESET_BILLING_ADDRESS_FILTERS,
    };
}
// L O A D   B I L L I N G   A D D R E S S E S   F I L T E R

// S E T   D I S A B L E   S H I P P I N G   A D D R E S S
export function setDisableShippingAddress(value, key, customerId) {
    return {
        type: CustomerTypes.SET_DISABLE_SHIPPING_ADDRESS,
        value,
        key,
        customerId,
    };
}

export function setDisableShippingAddressRes(data) {
    return {
        type: actionCreator(CustomerTypes.SET_DISABLE_SHIPPING_ADDRESS, 'res'),
        data,
    };
}
// S E T   D I S A B L E   S H I P P I N G   A D D R E S S

// S E T   D I S A B L E   B I L L I N G   A D D R E S S
export function setDisableBillingAddress(value, key, customerId) {
    return {
        type: CustomerTypes.SET_DISABLE_BILLING_ADDRESS,
        value,
        key,
        customerId,
    };
}

export function setDisableBillingAddressRes(data) {
    return {
        type: actionCreator(CustomerTypes.SET_DISABLE_BILLING_ADDRESS, 'res'),
        data,
    };
}
// S E T   D I S A B L E   B I L L I N G   A D D R E S S

// E D I T   A D D R E S S E S
export function editAddress(data) {
    return {
        type: CustomerTypes.EDIT_ADDRESS,
        data,
    };
}

export function editAddressRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.EDIT_ADDRESS, 'res'),
        loading,
        success,
    };
}

export function editAddressErr() {
    return {
        type: actionCreator(CustomerTypes.EDIT_ADDRESS, 'err'),
    };
}
// E D I T   A D D R E S S E S

// D E L E T E   A D D R E S S
export function deleteAddress(value, key, customerId) {
    return {
        type: CustomerTypes.DELETE_ADDRESS,
        value,
        key,
        customerId,
    };
}

export function deleteAddressRes(data) {
    return {
        type: actionCreator(CustomerTypes.DELETE_ADDRESS, 'res'),
        data,
    };
}
// D E L E T E   A D D R E S S

// L O A D   C U S T O M E R   O R D E R S
export function loadCustomerOrders(customerId) {
    return {
        type: CustomerTypes.LOAD_CUSTOMER_ORDERS,
        customerId,
    };
}

export function loadCustomerOrdersRes(data, neededData) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_ORDERS, 'res'),
        data,
        neededData,
    };
}

export function loadCustomerOrdersErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_ORDERS, 'err'),
    };
}
// L O A D   C U S T O M E R   O R D E R S

// S E T   C U S T O M E R   O R D E R S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T
export function setCustomerOrdersFilters(key, value) {
    return {
        type: CustomerTypes.SET_CUSTOMER_ORDERS_FILTER,
        key,
        value,
    };
}

export function setCustomerOrdersFiltersRes(data) {
    return {
        type: actionCreator(CustomerTypes.SET_CUSTOMER_ORDERS_FILTER, 'res'),
        data,
    };
}

export function setCustomerOrdersPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_CUSTOMER_ORDERS_PAGINATION,
        key,
        pagination,
    };
}

export function setCustomerOrdersSort(sort) {
    return {
        type: CustomerTypes.SET_CUSTOMER_ORDERS_SORT,
        sort,
    };
}

export function resetCustomerOrdersFilters() {
    return {
        type: CustomerTypes.RESET_CUSTOMER_ORDERS_FILTERS,
    };
}
// S E T   C U S T O M E R   O R D E R S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T

// L O A D   C U S T O M E R   Q U O T E S
export function loadCustomerQuotes(customerId) {
    return {
        type: CustomerTypes.LOAD_CUSTOMER_QUOTES,
        customerId,
    };
}

export function loadCustomerQuotesRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES, 'res'),
        data,
    };
}

export function loadCustomerQuotesErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES, 'err'),
    };
}
// L O A D   C U S T O M E R   Q U O T E S

// S E T   C U S T O M E R   Q U O T E S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T
export function setCustomerQuotesFilters(key, value) {
    return {
        type: CustomerTypes.SET_CUSTOMER_QUOTES_FILTER,
        key,
        value,
    };
}

export function setCustomerQuotesFiltersRes(data) {
    return {
        type: actionCreator(CustomerTypes.SET_CUSTOMER_QUOTES_FILTER, 'res'),
        data,
    };
}

export function setCustomerQuotesPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_CUSTOMER_QUOTES_PAGINATION,
        key,
        pagination,
    };
}

export function setCustomerQuotesSort(sort) {
    return {
        type: CustomerTypes.SET_CUSTOMER_QUOTES_SORT,
        sort,
    };
}

export function resetCustomerQuotesFilters() {
    return {
        type: CustomerTypes.RESET_CUSTOMER_QUOTES_FILTERS,
    };
}
// S E T   C U S T O M E R   Q U O T E S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T

// L O A D   C U S T O M E R   Q U O T E S   C O N T A C T
export function loadCustomerQuotesContact(customerId) {
    return {
        type: CustomerTypes.LOAD_CUSTOMER_QUOTES_CONTACT,
        customerId,
    };
}

export function loadCustomerQuotesContactRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_CONTACT, 'res'),
        data,
    };
}

export function loadCustomerQuotesContactErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_CONTACT, 'err'),
    };
}
// L O A D   C U S T O M E R   Q U O T E S   C O N T A C T

// L O A D   C U S T O M E R   Q U O T E S   S E N D E R
export function loadCustomerQuotesSender(customerId) {
    return {
        type: CustomerTypes.LOAD_CUSTOMER_QUOTES_SENDER,
        customerId,
    };
}

export function loadCustomerQuotesSenderRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_SENDER, 'res'),
        data,
    };
}

export function loadCustomerQuotesSenderErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_SENDER, 'err'),
    };
}
// L O A D   C U S T O M E R   Q U O T E S   S E N D E R

// S E T   C U S T O M E R   T A B
export function setCustomerTab(tab) {
    return {
        type: CustomerTypes.SET_CUSTOMER_TAB,
        tab,
    };
}
// S E T   C U S T O M E R   T A B

// A D D   C U S T O M E R   I N V O I C E
export function addNewInvoice(invoice, products) {
    return {
        type: CustomerTypes.ADD_NEW_INVOICE,
        invoice,
        products,
    };
}

export function addNewInvoiceRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_INVOICE, 'res'),
        loading,
        success,
    };
}

export function addNewInvoiceErr(error) {
    return {
        type: actionCreator(CustomerTypes.ADD_NEW_INVOICE, 'err'),
        error,
    };
}
// A D D   C U S T O M E R   I N V O I C E

// L O A D   C U S T O M E R   I N V O I C E S   W I T H   P A G I N A T I O N  &  S O R T
export function loadCustomerInvoices(customerId) {
    return {
        type: CustomerTypes.LOAD_CUSTOMER_INVOICES,
        customerId,
    };
}

export function loadCustomerInvoicesRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_INVOICES, 'res'),
        data,
    };
}

export function loadCustomerInvoicesErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_INVOICES, 'err'),
    };
}

export function setCustomerInvoicesPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_CUSTOMER_INVOICES_PAGINATION,
        key,
        pagination,
    };
}

export function setCustomerInvoicesSort(key, type) {
    return {
        type: CustomerTypes.SET_CUSTOMER_INVOICES_SORT,
        sort: {
            key,
            type,
        },
    };
}
// L O A D   C U S T O M E R   I N V O I C E S   W I T H   P A G I N A T I O N  &  S O R T


// L O A D   C U S T O M E R   I N V O I C E S   F I L T E R S
export function setCustomerInvoicesFilters(key, value) {
    return {
        type: CustomerTypes.SET_CUSTOMER_INVOICES_FILTER,
        key,
        value,
    };
}

export function resetCustomerInvoicesFilters() {
    return {
        type: CustomerTypes.RESET_CUSTOMER_INVOICES_FILTERS,
    };
}
// L O A D   C U S T O M E R   I N V O I C E S   F I L T E R S

// L O A D   C U S T O M E R   P R O F O R M A   W I T H   P A G I N A T I O N  &  S O R T
export function loadCustomerProforma(customerId) {
    return {
        type: CustomerTypes.LOAD_CUSTOMER_PROFORMA,
        customerId,
    };
}

export function loadCustomerProformaRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_PROFORMA, 'res'),
        data,
    };
}

export function loadCustomerProformaErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_PROFORMA, 'err'),
    };
}

export function setCustomerProformaPagination(key, pagination) {
    return {
        type: CustomerTypes.SET_CUSTOMER_PROFORMA_PAGINATION,
        key,
        pagination,
    };
}

export function setCustomerProformaSort(key, type) {
    return {
        type: CustomerTypes.SET_CUSTOMER_PROFORMA_SORT,
        sort: {
            key,
            type,
        },
    };
}
// L O A D   C U S T O M E R   P R O F O R M A   W I T H   P A G I N A T I O N  &  S O R T

// S E T   C H E C K E D   &&   S E L E C T E D   C U S T O M E R   P R O F O R M A
export function setCheckedCustomerProforma(ids) {
    return {
        type: CustomerTypes.SET_CHECKED_CUSTOMER_PROFORMA,
        ids,
    };
}

export function selectCustomerProforma(ids) {
    return {
        type: CustomerTypes.SELECT_CUSTOMER_PROFORMA,
        ids,
    };
}
// S E T   C H E C K E D   &&   S E L E C T E D   C U S T O M E R   P R O F O R M A

// L O A D   C U S T O M E R   P R O F O R M A   F I L T E R S
export function setCustomerProformaFilters(key, value) {
    return {
        type: CustomerTypes.SET_CUSTOMER_PROFORMA_FILTER,
        key,
        value,
    };
}

export function resetCustomerProformaFilters() {
    return {
        type: CustomerTypes.RESET_CUSTOMER_PROFORMA_FILTERS,
    };
}
// L O A D   C U S T O M E R   P R O F O R M A   F I L T E R S

// L O A D   B I L L I N G   A D D R E S S   F O R   F I N A N C E
export function loadBillingAddressForFinance(id) {
    return {
        type: CustomerTypes.LOAD_BILLING_ADDRESS_FOR_FINANCE,
        id,
    };
}

export function loadBillingAddressForFinanceRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_BILLING_ADDRESS_FOR_FINANCE, 'res'),
        data,
    };
}

export function loadBillingAddressForFinanceErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_BILLING_ADDRESS_FOR_FINANCE, 'err'),
    };
}

export function setEmptyBillingAddressForFinance() {
    return {
        type: CustomerTypes.SET_EMPTY_BILLING_ADDRESS_FOR_FINANCE,
    };
}
// L O A D   B I L L I N G   A D D R E S S   F O R   F I N A N C E

// L O A D    I N V O I C E   D E T A I L S
export function loadInvoiceDetails(invoiceId) {
    return {
        type: CustomerTypes.LOAD_INVOICE_DETAILS,
        invoiceId,
    };
}

export function loadInvoiceDetailsRes(data) {
    return {
        type: actionCreator(CustomerTypes.LOAD_INVOICE_DETAILS, 'res'),
        data,
    };
}

export function loadInvoiceDetailsErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_INVOICE_DETAILS, 'err'),
    };
}
// L O A D    I N V O I C E   D E T A I L S

// L O A D   C U S T O M E R   T U R N O V E R
export function loadCustomerTurnover(id) {
    return {
        type: CustomerTypes.LOAD_CUSTOMER_TURNOVER,
        id,
    };
}

export function loadCustomerTurnoverRes(data2Months, dataTotal) {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_TURNOVER, 'res'),
        data2Months,
        dataTotal,
    };
}

export function loadCustomerTurnoverErr() {
    return {
        type: actionCreator(CustomerTypes.LOAD_CUSTOMER_TURNOVER, 'err'),
    };
}

export function setEmptyCustomerTurnover() {
    return {
        type: CustomerTypes.SET_EMPTY_CUSTOMER_TURNOVER,
    };
}
// L O A D   C U S T O M E R   T U R N O V E R

// D O W N L O A D   A L L   I N V O I C E S
export function downloadAllInvoices(data, invoiceType, invoiceAction, limit) {
    return {
        type: CustomerTypes.DOWNLOAD_ALL_INVOICES,
        data,
        invoiceType,
        invoiceAction,
        limit,
    };
}

export function downloadAllInvoicesRes(loading, success, invoiceType, invoiceAction) {
    return {
        type: actionCreator(CustomerTypes.DOWNLOAD_ALL_INVOICES, 'res'),
        loading,
        success,
        invoiceType,
        invoiceAction,
    };
}

export function downloadAllInvoicesErr(error, invoiceType, invoiceAction) {
    return {
        type: actionCreator(CustomerTypes.DOWNLOAD_ALL_INVOICES, 'err'),
        error,
        invoiceType,
        invoiceAction,
    };
}
// D O W N L O A D   A L L   I N V O I C E S


// C R E A T E   G R O U P E D   I N V O I C E
export function createGroupedInvoice(data, contact) {
    return {
        type: CustomerTypes.CREATE_GROUPED_INVOICE,
        data,
        contact,
    };
}

export function createGroupedInvoiceRes(loading, success) {
    return {
        type: actionCreator(CustomerTypes.CREATE_GROUPED_INVOICE, 'res'),
        loading,
        success,
    };
}

export function createGroupedInvoiceErr(error) {
    return {
        type: actionCreator(CustomerTypes.CREATE_GROUPED_INVOICE, 'err'),
        error,
    };
}
// C R E A T E   G R O U P E D   I N V O I C E

// G E N E R A T E   C R E D I T   N O T E   I N V O I C E
export function generateCreditNoteInvoice(data) {
    return {
        type: CustomerTypes.GENERATE_CREDIT_NOTE_INVOICE,
        data,
    };
}

export function generateCreditNoteInvoiceRes() {
    return {
        type: actionCreator(CustomerTypes.GENERATE_CREDIT_NOTE_INVOICE, 'res'),
    };
}

export function generateCreditNoteInvoiceErr() {
    return {
        type: actionCreator(CustomerTypes.GENERATE_CREDIT_NOTE_INVOICE, 'err'),
    };
}
// G E N E R A T E   C R E D I T   N O T E   I N V O I C E
// R E G E N E R A T E   P R O F O R M A
export function regenerateProforma(data) {
    return {
        type: CustomerTypes.REGENERATE_PROFORMA,
        data,
    };
}

export function regenerateProformaRes(id) {
    return {
        type: actionCreator(CustomerTypes.REGENERATE_PROFORMA, 'res'),
        id,
    };
}

export function regenerateProformaErr() {
    return {
        type: actionCreator(CustomerTypes.REGENERATE_PROFORMA, 'err'),
    };
}
// R E G E N E R A T E   P R O F O R M A
